
import { personActions } from '../store/reducers/person';

export function LoadUser(store: any): void {
    if (!store || !store.dispatch) {
        return;
    }

    store.dispatch(personActions.loadAuthenticated());
};